import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  Link,
  Popover,
  List,
} from "@mui/material";
import React from "react";

export function sourcesToElements(sources: any[]) {
  let elements = sources.map(function (source) {
    return (
      <ListItem alignItems="flex-start" className="source-item">
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={"https://www.google.com/s2/favicons?domain=" + new URL(source["url"]).hostname + "/favicon.ico"}
          />
        </ListItemAvatar>
        <Link
          href={source["url"]}
          underline="none"
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <ListItemText
            style={{ textAlign: "justify" }}
            primary={source["title"]}
            primaryTypographyProps={{
              fontSize: "14px",
            }}
            secondaryTypographyProps={{
              fontSize: "12px"
            }}
            secondary={
              <React.Fragment>
                <Typography
                  sx={{ display: "inline", fontSize: "12px" }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                  {source["author"]}
                </Typography>
                {(source["author"] ? " - " : "") + source["description"]}
              </React.Fragment>
            }
          />
        </Link>
      </ListItem>
    );
  });
  return <div>{elements}</div>;
}

export function sourcesToElementsWithDetail(sources: any[]) {
  let elements = sources.map(function (source) {
    return (
      <ListItem alignItems="flex-start" className="source-item">
        <ListItemAvatar>
          <Avatar
            alt={source["source"]}
            src={"https://www.google.com/s2/favicons?domain=" + new URL(source["url"]).hostname + "/favicon.ico"}
          />
        </ListItemAvatar>
        <Link
          href={source["url"]}
          underline="none"
          target={"_blank"}
          rel="noopener noreferrer"
        >
          <ListItemText
            style={{ textAlign: "justify" }}
            primary={source["title"]}
            primaryTypographyProps={{
              fontSize: "14px",
            }}
            secondaryTypographyProps={{
              fontSize: "12px"
            }}
            secondary={
              <React.Fragment>
                <Typography
                  sx={{ display: "inline", fontSize: "12px" }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                  {source["author"]}
                </Typography>
                {(source["author"] ? " - " : "") + source["description"]}
              </React.Fragment>
            }
          />
        </Link>
      </ListItem>
    );
  });
  return <div>{elements}</div>;
}

function titleElement(title: string) {
  return (
    <ListItem>
      <ListItemText
        primary={title}
        primaryTypographyProps={{
          fontSize: "25px",
          fontWeight: 500,
          align: "center",
        }}
      />
    </ListItem>
  );
}

type ContentListPopupProps = {
  popup: any;
  onClosePopup: any;
  contents: any;
  title: string;
};

export default function ContentListPopup(props: ContentListPopupProps) {
  return (
    <Popover
      open={props.popup}
      onClose={props.onClosePopup}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      sx={{
        marginTop: "25px",
        minHeight: "100vh"
      }}
      
    >
      <List
        sx={{
          width: "700px",
          maxWidth: "50vw",
          height: "100vh",
          bgcolor: "background.paper",
          flexWrap: "wrap",
        }}
      >
        {titleElement(props.title)}
        {sourcesToElements(props.contents)}
      </List>
    </Popover>
  );
}
